module.exports = __webpack_public_path__ + "static/media/TV-Logo_short.74b00253.svg";